document.addEventListener('DOMContentLoaded', function () {
    // Detect if we are in the editor
    if (window.location.pathname.includes('/wp-admin/')) {
        return; // Don't run AJAX in the editor
    }


    (function ($) {
        $(document).ready(function () {
            // Detect all forms with data-form-id
            const formElements = $('form[data-form-id]');
            // Ensure blockEmailDomains is available
			let blockEmailDomains = ['true', true, 1, '1'].includes(hubspotform_block_email_domains?.blockEmailDomains);


            formElements.each(function () {
                const formElement = $(this);
                const formName = formElement.data('form-id');
                let formStarted = false;
                let impressionTracked = false;
                let prefillTracked = false;
				const container = formElement.closest('.hubspot-form-container');
				const blockInstanceId = container.data('unique-id');

				// Check the GeoIP country code from the server. EEA, the UK and Switzerland. (The EEA comprises the EU Member States and Iceland, Liechtenstein, and Norway).
                const geoCountryCode = $('meta[name="geoip-country-code"]').attr('content');
				const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'IS', 'LI', 'NO', 'GB', 'CH'];

                if (euCountries.includes(geoCountryCode)) {
                    formElement.find('#consent').closest('label').show(); // Ensure the label is visible
                    formElement.find('#consent').prop('checked', false);  // Reset the checkbox state (uncheck by default)
                } else {
                    formElement.find('#consent').prop('checked', true);  // Ensure it's checked
                    formElement.find('#consent').closest('label').hide(); // Hide the label
                }

                // Access the localized REST API URL and nonce
                const restUrl = hubspotform_rest_obj_think_blocks_hubspot_form.rest_url;
                const nonce = hubspotform_rest_obj_think_blocks_hubspot_form.nonce;

                if (!restUrl || !nonce) {
                    console.error('REST URL or nonce is missing.');
                    return;
                }

                // Function to fetch user data from HubSpot using contact Email
                function fetchUserData(email) {
                    return $.ajax({
						url: restUrl + '/hubspot-form/get-user-data',
                        method: 'GET',
                        data: { email: email },
                        beforeSend: function (xhr) {
                            xhr.setRequestHeader('X-WP-Nonce', nonce);
                        }
                    });
                }

                // Function to prefill the form fields
                function prefillForm(data) {
					// Get UserProfile cookie as fallback for missing data
					const userProfile = typeof Cookies !== 'undefined' && Cookies.get('UserProfile')
						? JSON.parse(Cookies.get('UserProfile'))
						: {};

                    formElement.find('#email').val(data.email || '');
					if (formElement.find('#firstname').length) {
						formElement.find('#firstname').val(data.firstname || '');
					}
					if (formElement.find('#lastname').length) {
						formElement.find('#lastname').val(data.lastname || '');
					}
					if (formElement.find('#company').length) {
						formElement.find('#company').val(data.company || '');
					}
					if (formElement.find('#phone').length) {
						formElement.find('#phone').val(data.phone || '');
					}
					if (formElement.find('#website').length) {
						formElement.find('#website').val(data.website || '');
					}
									// Handle select fields with proper timing
				setTimeout(() => {
					// Use HubSpot data first, fallback to UserProfile cookie
					const rangeVal = data.employee_range__c || userProfile.employee_range__c || '';
					const useCaseVal = data.probable_use_case || userProfile.probable_use_case || '';

					console.log('➡ Trying to set employee_range__c to:', rangeVal);
					console.log('➡ Trying to set probable_use_case to:', useCaseVal);

					const $employeeRange = formElement.find('#employee_range__c');
					const $useCase = formElement.find('#probable_use_case');

					if ($employeeRange.length && rangeVal) {
						const match = $employeeRange.find(`option[value="${rangeVal}"]`);
						console.log('🔍 employee_range__c option match:', match.length ? 'FOUND' : 'NOT FOUND');
						console.log('#employee_range__c options count:', $employeeRange.find('option').length);

						if (match.length) {
							$employeeRange.val(rangeVal);
							$employeeRange[0].value = rangeVal; // Ensure DOM property is set
							$employeeRange.trigger('change');
							$employeeRange.addClass('prefilled');
							
							// Hide the field group when prefilled
							const fieldGroup = $employeeRange.closest('.wp-block-group, .hidden-field');
							if (fieldGroup) {
								fieldGroup.removeClass('visible-field').addClass('hidden-field');
							}
						}
					}

					if ($useCase.length && useCaseVal) {
						const match = $useCase.find(`option[value="${useCaseVal}"]`);
						console.log('🔍 probable_use_case option match:', match.length ? 'FOUND' : 'NOT FOUND');
						console.log('#probable_use_case options count:', $useCase.find('option').length);

						if (match.length) {
							$useCase.val(useCaseVal);
							$useCase[0].value = useCaseVal; // Ensure DOM property is set
							$useCase.trigger('change');
							$useCase.addClass('prefilled');
							
							// Hide the field group when prefilled
							const fieldGroup = $useCase.closest('.wp-block-group, .hidden-field');
							if (fieldGroup) {
								fieldGroup.removeClass('visible-field').addClass('hidden-field');
							}
						}
					}
				}, 250);
									

					// Checkbox (e.g., consent) - use HubSpot data first, fallback to UserProfile
					const $consent = formElement.find('#consent');
					if ($consent.length) {
						const consentValue = data.consent || userProfile.consent;
						const isChecked = consentValue === 'true' || consentValue === true;
						$consent.prop('checked', isChecked);
					}
					
					
                }

                // Initialize form prefill
				function initializeFormPrefill() {
					let prefillSource = "none";
					const userProfile = typeof Cookies !== 'undefined' && Cookies.get('UserProfile')
						? JSON.parse(Cookies.get('UserProfile'))
						: {};
					const email = userProfile.email || '';

					if (email) {
						prefillSource = "profile";
						fetchUserData(email)
							.done(function (response) {
								if (response.success && response.contactData) {
									const contact = response.contactData;

									// Only update cookie if at least one key field has non-empty value
									const hasValidData = contact.firstname || contact.lastname || contact.company || contact.phone || contact.website;

									if (hasValidData) {
										userProfile.firstname = contact.firstname || userProfile.firstname;
										userProfile.lastname = contact.lastname || userProfile.lastname;
										userProfile.email = contact.email || userProfile.email;
										userProfile.company = contact.company || userProfile.company;
										userProfile.phone = contact.phone || userProfile.phone;
										userProfile.website = contact.website || userProfile.website;
										userProfile.employee_range__c = contact.employee_range__c || userProfile.employee_range__c;
										userProfile.probable_use_case = contact.probable_use_case || userProfile.probable_use_case;
										userProfile.consent = contact.consent || userProfile.consent;

										if (!window.location.pathname.includes('/wp-admin/')) {
											Cookies.set('UserProfile', JSON.stringify(userProfile), {
												expires: 30,
												path: '/',
												sameSite: 'Lax'
											});
										}

										// Increased delay to ensure form-field-mapping.js completes first
										setTimeout(() => {
											prefillForm(contact);
										}, 200);

										if (!prefillTracked) {
											prefillTracked = true;
											window.dataLayer.push({
												block_instance_id: blockInstanceId,
												event: "form_interaction",
												event_type: "form_prefill",
												form_name: formName,
												form_prefill_source: prefillSource,
											});
										}
									} else {
										console.warn('Fetched contact data is empty. Cookie not updated.');
									}
								} else {
									console.warn('Failed to fetch user data:', response.message);
								}
							})
							.fail(function (jqXHR, textStatus, errorThrown) {
								console.error('AJAX request failed:', textStatus, errorThrown);
							});
					}
				}

				// Execute the prefill on page load with a small delay to ensure form-field-mapping.js completes
				setTimeout(() => {
					initializeFormPrefill();
				}, 50);				

                // Detect when form is in viewport
                const observer = new IntersectionObserver(
                    function (entries) {
                        entries.forEach(entry => {
                            if (entry.isIntersecting) {
                                if (!impressionTracked) {
                                    impressionTracked = true;
                                    window.dataLayer.push({
										block_instance_id: blockInstanceId,
                                        event: "form_interaction",
										event_type: "form_impression",
                                        form_name: formName,
                                    });
                                }

                                if (!prefillTracked) {
                                    initializeFormPrefill();
                                    observer.unobserve(formElement[0]);
                                }
                            }
                        });
                    },
                    { threshold: 0.3 } 
                );

                observer.observe(formElement[0]);
                
                // Track when a user starts interacting with the form
                formElement.find('input, textarea, select').one('focus', function () {
                    if (!formStarted) {
                        formStarted = true;
                        window.dataLayer.push({
							block_instance_id: blockInstanceId,
                            event: "form_interaction",
							event_type: "form_started",
                            form_name: formName,
                        });
                    }
                });    

                // Track completed fields
                let completedFields = new Set();
                
				// Remove error messages when user starts typing again
				formElement.find('input, textarea, select').on('input', function () {
					if ($(this).hasClass('input-error')) {
						$(this).removeClass('input-error').siblings('.form-error').remove();
					}
				});

                // Attach validation when a user clicks out of a field (blur event)
                formElement.find('input, textarea, select').on('blur', function () {
                    const fieldName = $(this).attr('name');
                    const value = $(this).val().trim();
                    const errors = {};

                    const isRequired = $(this).is('[required]') || $(this).attr('aria-required') === 'true';

					if (typeof thinkBlocksL10n === 'undefined') {
						console.warn('thinkBlocksL10n is missing. Validation messages may not appear.');
						window.thinkBlocksL10n = {
							validEmailError: 'Please enter a valid email address.',
							emailbusinessError: 'We require a business email.',
							firstnameRequired: 'First Name is required.',
							lastnameRequired: 'Last Name is required.',
							emailRequired: 'Email is required.',
							companyRequired: 'Company is required.',
							phoneNumberRequired: 'Phone Number is required.',
							websiteRequired: 'Company website is required.',
							employee_range__cRequired: 'Please select your company size.',
							probable_use_caseRequired: 'Please select your primary use case.',
							consentRequired: 'Consent is required.',
							requiredField: 'This field is required.',
							generalError: 'Something went wrong. Please try again.',
						};
					}

                    if (isRequired && !value) {
                        errors[fieldName] = thinkBlocksL10n[fieldName + "Required"] || "This field is required";
                        completedFields.delete(fieldName);
                    } else {
                        switch (fieldName) {
							case 'email':
								const emailInput = value.trim();
								const emailParts = emailInput.split('@');
								const emailDomain = emailParts.length > 1 ? emailParts[1].toLowerCase() : '';

								

								if (!validateEmail(emailInput)) {
									errors.email = thinkBlocksL10n.validEmailError;
								} else if (blockEmailDomains) {
									const blockedDomains = hubspotBlockedDomains?.blockedDomains || [];
									if (blockedDomains.includes(emailDomain)) {
										errors.email = thinkBlocksL10n.emailbusinessError;
									}
								}
								break;
                            case 'phone':
                                if (formElement.find('#phone').is(':visible') && !validatePhone(value)) {
                                    errors.phone = thinkBlocksL10n.validPhoneError;
                                    completedFields.delete(fieldName);
                                }
                                break;
                            case 'website':
                                if (formElement.find('#website').is(':visible') && !validateWebsite(value)) {
                                    errors.website = thinkBlocksL10n.validUrlError;
                                    completedFields.delete(fieldName);
                                }
                                break;
							case 'employee_range__c':
								if (formElement.find('#employee_range__c').is(':visible') && !value) {
									errors.employee_range__c = thinkBlocksL10n.employee_range__cRequired || "Please select your company size";
									completedFields.delete(fieldName);
								}
								break;
							case 'probable_use_case':
								if (formElement.find('#probable_use_case').is(':visible') && !value) {
									errors.probable_use_case = thinkBlocksL10n.probable_use_caseRequired || "Please select your primary use case";
									completedFields.delete(fieldName);
								}
								if (value === 'Support for my Thinkific Account') {
									formElement.find('#support-message').show();
								} else {
									formElement.find('#support-message').hide();
								}
								break;
                            case 'consent': 
                                const consentInput = formElement.find('#consent');
                                if (consentInput.length && consentInput.is(':visible') && !consentInput.is(':checked')) {
                                    errors.consent = thinkBlocksL10n.consentRequired;
                                }
                                return;
                        }
                    }

                    $(this).siblings('.form-error').remove();

                    if (Object.keys(errors).length > 0) {
                        for (const [field, message] of Object.entries(errors)) {
							const inputField = formElement.find(`[name="${field}"]`);
                            if (inputField.length) {
                                inputField.after(`<p class="form-error">${message}</p>`);
                                inputField.addClass('input-error');
                            }
                        }
                    } else {
                        $(this).removeClass('input-error').siblings('.form-error').remove();
                        completedFields.add(fieldName);

                        // Push successful field completion to dataLayer
                        window.dataLayer.push({
							block_instance_id: blockInstanceId,
                            event: "form_interaction",
							event_type: "form_field_completed",
                            form_name: formName,
                            field_name: fieldName,
                        });
                    }
                    // If all fields are completed, push form completed event to dataLayer
                    const totalVisibleFields = formElement.find(
                        'input:not([type="hidden"]):not(.hidden-field):not(#consent), textarea:not(.hidden-field), select:not(.hidden-field)'
                    ).filter(function () {
                        return $(this).css('display') !== 'none' && $(this).is('[required], [aria-required="true"]');
                    }).length;
                
                    if (completedFields.size === totalVisibleFields) {
                        window.dataLayer.push({
							block_instance_id: blockInstanceId,
                            event: "form_interaction",
							event_type: "form_completed",
                            form_name: formName,
                        });
                    }
                });
                
				// Show or hide the support message based on the selected use case
				formElement.find('#probable_use_case').on('change', function () {
					const value = $(this).val();
					if (value === 'Support for my Thinkific Account') {
						formElement.find('#support-message').show();
					} else {
						formElement.find('#support-message').hide();
					}
				});

                // Handle form submission via AJAX
                formElement.on('submit', function (e) {
                    e.preventDefault();
					const clientErrors = {};

                    // Find hidden fields and store their names
                    const visibleFields = [];
                    formElement.find('.wp-block-group:not(.hidden-field) input, .wp-block-group:not(.hidden-field) textarea, .wp-block-group:not(.hidden-field) select').each(function () {
                        const fieldName = $(this).attr('name');
                        if (fieldName) {
                            visibleFields.push(fieldName);
                        }
                    });
                
                    // Add the `visible_fields` data as a hidden input
                    const visibleFieldsInput = $('<input>')
                        .attr('type', 'hidden')
                        .attr('name', 'visible_fields')
                        .val(JSON.stringify(visibleFields));
                
                    formElement.append(visibleFieldsInput);

                    // Clear existing messages and errors
					clearErrors(formElement);
					clearMessages(formElement);

                    // Retrieve blockEmailDomains again before submission
					let blockEmailDomains = ['true', true, 1, '1'].includes(hubspotform_block_email_domains?.blockEmailDomains);

					// Detect if user is in the EU based on country code meta tag
					const geoCountryCode = $('meta[name="geoip-country-code"]').attr('content');
					const euCountries = ['AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI', 'FR', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV', 'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK', 'IS', 'LI', 'NO', 'GB', 'CH'];
					const userInEU = euCountries.includes(geoCountryCode);

					// Find the consent checkbox
					const consentInput = formElement.find('#consent');
					const consentLabel = consentInput.closest('label');

                    formElement.find('input, textarea, select').each(function () {
                        const fieldName = $(this).attr('name');
                        const value = $(this).val().trim();
                        const isRequired = $(this).is('[required]') || $(this).attr('aria-required') === 'true';

                        if (isRequired && !value) {
                            clientErrors[fieldName] = thinkBlocksL10n[fieldName + "Required"] || "This field is required";
                        }
                    });

					// Check if consent is required and not checked
					if (userInEU && consentInput.length && !consentInput.is(':checked')) {
						clientErrors['legalConsentOptions'] = "You must agree to the terms and conditions to proceed.";

						// Ensure the error is displayed next to the checkbox
						consentInput.addClass('input-error');

						// Ensure `consentLabel` is correctly referenced**
						if (consentLabel.length) {
							consentLabel.find('.form-error').remove(); // Remove existing error message
							consentLabel.append('<p class="form-error">You must agree to the terms and conditions to proceed.</p>');
						} else {
							// If `label` is missing, insert error message right after the checkbox
							consentInput.after('<p class="form-error">You must agree to the terms and conditions to proceed.</p>');
						}
					}

                    // If any errors exist, stop form submission
                    if (Object.keys(clientErrors).length > 0) {
						displayErrors(clientErrors, formElement);
                        return;
                    }
					const formId = formElement.data('form-id');

					// Collect hidden field data
					const hiddenInputs = formElement.find('input[type="hidden"]');
					
					let hiddenFieldData = {};
					hiddenInputs.each(function () {
						hiddenFieldData[$(this).attr('name')] = $(this).val();
					});

					function getFieldValue(selector) {
						const el = formElement.find(selector);
						return el.length ? el.val() : '';
					}

					const formData = {
						formId: formId,
						firstname: getFieldValue('#firstname'),
						lastname: getFieldValue('#lastname'),
						email: getFieldValue('#email'),
						company: getFieldValue('#company'),
						phone: getFieldValue('#phone'),
						website: getFieldValue('#website'),
						employee_range__c: getFieldValue('#employee_range__c'),
						probable_use_case: getFieldValue('#probable_use_case'),
						hutk: Cookies.get('hubspotutk') || '',
						pageUri: window.location.pathname,
						pageName: document.title,
						blockEmailDomains: blockEmailDomains,
						redirectUrl: formElement.data('redirect-url') || '',
					};

					$.each(hiddenFieldData, function (key, value) {
						formData[key] = value;
					});
					
					// Include consent data only if user is in the EU
					if (userInEU) {
						formData.legalConsentOptions = {
							consent: {
								consentToProcess: consentInput.is(':checked') ? 'true' : 'false',
								text: "I agree to allow Company Name to store and process my personal data.",
								communications: [
									{
										value: consentInput.is(':checked') ? 'true' : 'false',
										subscriptionTypeId: 466761704,
										text: "I agree to receive marketing communications."
									}
								]
							}
						};
					}

					// Prevent submission if 'Support for my Thinkific Account' is selected
					const useCaseVal = formElement.find('#probable_use_case').val();
					if (useCaseVal === 'Support for my Thinkific Account') {
						const errorMsg = 'Please contact support directly.';
						displayErrors({ probable_use_case: errorMsg });

						formElement.find('#support-message').show();
						return;
					} else {
						formElement.find('#support-message').hide();
					}

                    // Trigger reCAPTCHA execution
                    grecaptcha.ready(function () {
                        grecaptcha.execute('6Lc38q8qAAAAAOCUm8Ar7Mc4nSNYK08yIyrj4Ez-', { action: 'submit' }).then(function (token) {
                            formData['g-recaptcha-response'] = token;
							
							let submitButton = $(this).find('button[type="submit"]');
							submitButton.prop('disabled', true);
							
							if (formId) {
								formElement.find('#loading-spinner').show();
							}

                            $.ajax({
								url: restUrl + '/hubspot-form/submit',
                                method: 'POST',
                                beforeSend: function (xhr) {
                                    xhr.setRequestHeader('X-WP-Nonce', nonce);
                                },
                                data: JSON.stringify(formData),
                                contentType: 'application/json',
                                success: function (response) {
                                    let formElement = document.querySelector(`form[data-form-id="${formName}"]`);
                                    if (!formElement) {
                                        return;
                                    }
                                    let $formElement = $(formElement);
                                    let formProgressiveFilled = formElement.dataset.progressiveFilled === "true";
                                    let formPrefillSource = formElement.dataset.prefillSource || 'none';

									if (formId) {
										window.dataLayer.push({
											block_instance_id: blockInstanceId,
											event: "form_interaction",
											event_type: "form_submission",
											form_name: formName,
											form_progressive_filled: formProgressiveFilled,
											form_prefill_source: formPrefillSource,
											form_data: formData,
										});
									}

                                    if (response.success) {
										const redirectUrl = $(formElement).data('redirect-url');
										const userEmail = formData.email;

										// Redirect-only: skip spinner and thank-you if no HubSpot form
										if (!formId && redirectUrl) {
											const emailValue = $formElement.find('input[name="email"]').val();
											const redirectWithParam = new URL(redirectUrl);
											if (emailValue) {
												redirectWithParam.searchParams.set('email', emailValue);
											}
											window.location.href = redirectWithParam.toString();
											return;
										}

										// Otherwise, proceed as usual

                                        // Hide form and show thank-you message
                                        $formElement.find('#form-fields').hide();
                                        $formElement.find('#thank-you-message').show();
                                        
										// Store updated data in cookie
										let userProfileData;

										if (response.contactData) {
											// Use enriched HubSpot contact data
											userProfileData = {
												firstname: response.contactData.firstname || '',
												lastname: response.contactData.lastname || '',
												email: response.contactData.email || '',
												company: response.contactData.company || '',
												phone: response.contactData.phone || '',
												website: response.contactData.website || '',
												employee_range__c: response.contactData.employee_range__c || '',
												probable_use_case: response.contactData.probable_use_case || '',
												consent: response.contactData.consent || '',
											};
										} else {
											// Fallback to submitted form data (minus g-recaptcha)
											const { 'g-recaptcha-response': _, ...submitted } = formData;
											userProfileData = submitted;
										}

										if (!window.location.pathname.includes('/wp-admin/')) {
											Cookies.set('UserProfile', JSON.stringify(userProfileData), {
												expires: 7,
												path: '/',
												sameSite: 'Lax',
											});
										}
										
										// redirect based on chosen url and append email
										if (!formId && redirectUrl) {
											const emailValue = $formElement.find('input[name="email"]').val();
											const redirectWithParam = new URL(redirectUrl);
											if (emailValue) {
												redirectWithParam.searchParams.set('email', emailValue);
											}
											window.location.href = redirectWithParam.toString();
											return; // Exit before HubSpot submission
										}

										if (redirectUrl) {
											// Append ?email= or &email= depending on whether the URL already has query params
											const separator = redirectUrl.includes('?') ? '&' : '?';
											const finalUrl = `${redirectUrl}${separator}email=${encodeURIComponent(userEmail)}`;

											window.location.href = finalUrl;
											return; // prevent further actions (e.g. showing thank-you-message)
										}

                                        // Scroll to the top of .hubspot-form-container
										const thankYouMessage = $formElement.find('#thank-you-message')[0];
										if (thankYouMessage) {
											thankYouMessage.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
										}

                                    } else if (response.errors) {
                                        displayErrors(response.errors);
                                    }
                                },
                                error: function (xhr) {
									if (formId) {
										formElement.find('#loading-spinner').hide();
									}
									submitButton.prop('disabled', false);

                                    let errorResponse;
                                    try {
                                        errorResponse = JSON.parse(xhr.responseText);
                                    } catch (e) {
                                        console.error('Error parsing server response:', e);
                                    }

                                    // Push submit error to dataLayer
                                    window.dataLayer.push({
										block_instance_id: blockInstanceId,
                                        event: "form_interaction",
										event_type: "form_sumbit_error",
                                        form_name: formName,
                                        message: errorResponse,
                                    });
                                    
                                    if (errorResponse && errorResponse.errors) {                                    
										displayErrors(errorResponse.errors, formElement);
									} else {
										formElement.find('.hubspot-form-container').prepend('<p class="form-error">An error occurred while submitting the form. Please try again.</p>');
									}
                                },
                                complete: function () {
                                    // Re-enable submit button and hide spinner
                                    formElement.find('#loading-spinner').hide();
                                    formElement.find('input[type="submit"], button[type="submit"]').prop('disabled', false);
                                },
                            });
                        });
                    });
                });
            });

            // Utility functions. Maybe move these to a separate file under src/js/scripts...
            function validateEmail(email) {
                const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
                return re.test(email);
            }

            function validatePhone(phone) {
                const re = /^\D?(\d{3})\D?\D?(\d{3})\D?(\d{4})$/;
                return re.test(phone);
            }

            function validateWebsite(website) {
                const re = /^(http|https):\/\/[^ "\n]+$/;
                return re.test(website);
            }

			function clearErrors(formElement) {
				formElement.find('.form-error').remove();
				formElement.find('.input-error').removeClass('input-error');
			}

			function displayErrors(errors, formElement) {
				for (const [field, message] of Object.entries(errors)) {
					if (field === 'legalConsentOptions') {
						const consentInput = formElement.find('#consent');
						const consentLabel = consentInput.closest('label');

						if (consentInput.length) {
							consentInput.addClass('input-error');
							consentLabel.find('.form-error').remove();
							consentLabel.append(`<p class="form-error">${message}</p>`);
						}
						continue;
					}

					if (field === 'submission') {
						formElement.prepend(`<p class="form-error">${message}</p>`);
						continue;
					}

					const inputField = formElement.find(`[name="${field}"]`);
					if (inputField.length) {
						inputField.addClass('input-error').after(`<p class="form-error">${message}</p>`);
					} else {
						console.warn(`No input field found for: ${field}`);
					}
				}

				const firstError = formElement.find('.form-error').first();
				if (firstError.length) {
					$('html, body').animate({
						scrollTop: firstError.offset().top - 20,
					}, 500);
				}
			}			

			function clearMessages(formElement) {
				formElement.find('.error-message, .form-error').remove();
			}			
        });
    })(jQuery);
});

